

















































































import { attachmentStatus } from '../../shared/enums/attachmentStatus.js';
import Vue, { computed, getCurrentInstance, PropType, ref } from 'vue';
import { mapGetters, mapMutations } from 'vuex';
import { types } from '../../src/store/types/types.js';
import Icon from './Icon.vue';
import { iconClassEnum } from '../enums/iconClassEnum';
import { AttachmentModel } from '../models/attachment.model';
import { useAttachmentScan } from '../composables/useAttachmentScan';
import { ScanningStatusEnum } from '../enums/scanningStatus.enum';
import { useUserProfileStore } from '../stores';

export default {
  components: { Icon },
  props: {
    attachments: { type: Array as PropType<AttachmentModel[]>, default: () => [] },
    showMedia: { type: Boolean, default: false },
    showFailedFiles: { type: Boolean, default: false },
    short: { type: Boolean, default: false },
  },
  setup(props) {
    const { proxy } = getCurrentInstance();
    const isMobile = computed(() => proxy.$store.getters[types.GET_IS_MOBILE]);
    const { institutionProfile } = useUserProfileStore();

    const visibleAttachments = computed(() =>
      props.attachments.filter(attachment => {
        if (attachment.status === attachmentStatus.UNAVAILABLE) {
          return false;
        }
        if (attachment.media != null && !props.showMedia) {
          return false;
        }
        const isBlocked =
          attachment.file?.scanningStatus === ScanningStatusEnum.BLOCKED ||
          attachment.media?.file?.scanningStatus === ScanningStatusEnum.BLOCKED;
        if (!isBlocked) {
          return true;
        }
        return attachment.creator?.profileId === institutionProfile.profileId;
      })
    );
    const getScanningText = (attachment: AttachmentModel) => {
      const attachmentRef = ref(attachment);
      const textLength = isMobile.value || props.short ? 'short' : 'long';
      const { scanningText } = useAttachmentScan(attachmentRef, textLength);
      return scanningText.value;
    };

    const isDisabled = (attachment: AttachmentModel) => {
      const attachmentRef = ref(attachment);
      const { isDisabled } = useAttachmentScan(attachmentRef);
      return isDisabled.value;
    };

    return {
      visibleAttachments,
      getScanningText,
      isDisabled,
      ScanningStatusEnum,
    };
  },
  data() {
    return {
      attachmentStatus: attachmentStatus,
      isLoading: false,
      externalLink: '',
      Vue: Vue,
    };
  },
  computed: {
    ...mapGetters({
      isSteppedUp: types.GET_GLOBAL_STEPPED_UP,
    }),
    iconClassEnum() {
      return iconClassEnum;
    },
  },
  methods: {
    ...mapMutations({
      setStepUpNotification: types.MUTATE_SET_NOTIFICATION_STEP_UP,
    }),
    getAttachmentTitle(attachment) {
      let attachmentTitle;
      if (attachment.document && attachment.document.isDeleted === true) {
        attachmentTitle = this.$getText('ATTACHMENT_HAS_BEEN_DELETED');
        return attachmentTitle;
      }

      attachmentTitle = attachment.name;
      if (attachment.document != null && !attachment.document.canAccess) {
        if (this.isSteppedUp) {
          attachmentTitle = this.$getText('ATTACHMENT_FILE_NAME_UNACCESSABLE');
        } else {
          attachmentTitle = this.$getText('ATTACHMENT_FILE_NAME_NOT_STEPPED_UP');
        }
      }
      return attachmentTitle;
    },
    onAttachmentClick(attachment) {
      if (this.isDisabled(attachment)) {
        return;
      }
      if (attachment.status === attachmentStatus.AVAILABLE) {
        if (attachment.file != null) {
          window.open(attachment.file.url);
        } else if (attachment.media != null) {
          window.open(attachment.media.file.url);
        } else if (attachment.link != null) {
          this.$refs.externalLinkWarningModal.show();
          this.externalLink = attachment.link.url;
        } else if (attachment.document != null && attachment.document.isDeleted === false) {
          if (attachment.document.canAccess) {
            this.$emit('openDocumentDrawer', {
              documentId: attachment.document.id,
              documentType: attachment.document.documentType,
            });
          } else if (!this.isSteppedUp) {
            this.setStepUpNotification({
              showStepUpNotification: true,
              redirectedUrl: window.location.href,
            });
          }
        }
      }
    },
    openExternalLink() {
      window.open(this.externalLink);
    },
    checkIsDocumentDisabled(attachment) {
      if (attachment.document != null) {
        if (attachment.document.isDeleted === true || attachment.document.canAccess === false) {
          return true;
        }
      }
      return false;
    },
  },
};
